/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, { useState, useEffect } from 'react';
import {Link, useParams} from "react-router-dom";
import PageBox from "../../layouts/pageBox";
import UsedPart from "../../assets/img/usedPart.jpg";
import ExtraCar from "../../assets/img/extraCar.jpg";
import ContactPic from "../../assets/img/contactPic.jpg";
import {ReactComponent as MapGreen} from "../../assets/img/icons/map-green.svg";
import {ReactComponent as Whatup} from "../../assets/img/icons/whatsapp.svg";
import {ReactComponent as ShowPhone} from "../../assets/img/login/show-phone.svg";
import {ReactComponent as Mail} from "../../assets/img/icons/send.svg";

import { FreeMode, Navigation, Pagination, A11y, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";


import RequestModal from "../../components/RequestModal";
import Loader from "../../elements/loader";
import PartBox from "../../components/PartBox";
import {ReactComponent as TimeGreen} from "../../assets/img/icons/time-green.svg";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";

import "yet-another-react-lightbox/styles.css";
import {Lightbox} from "yet-another-react-lightbox";
import LoginModal from "../../components/LoginModal";
import {useAuth} from "../../Hooks/useAuth";
import PartRequest from "./PartRequest";
import SEO from "../../components/SEO";
import JsonLdPartsProduct from "../../components/JsonLdPartsProduct";


const PartPage = () => {

    let params = useParams();
    const axiosJWT = useAxiosJTW();
    const { t, i18n } = useTranslation();

    const [partsImagesLightBox, setPartsImagesLightBox] = useState([]);
    const [openPartsLightBox, setOpenPartsLightBox] = useState(false);

    const [extraPartsImagesLightBox, setExtraPartsImagesLightBox] = useState([]);
    const [openExtraPartsLightBox, setOpenExtraPartsLightBox] = useState(false);

    const [adImagesLightBox, setAdImagesLightBox] = useState([]);
    const [openAdLightBox, setOpenAdLightBox] = useState(false);

    const [thumbsSwiper, setThumbsSwiper] = useState(null);


    const [part, setPart ] = useState({isLoading: true, data: {
        part: [],
        ad: {
            make_title:'',
            model_name:'',
            part_name: ''
        }
    }, error: false});

    const [headerData, setHeaderData] = useState({
        title : '',
        description : '',
        logo: ''
    });

    const getPartPage = (signal) => {
        axiosJWT.post('api/getpartpage', { make: decodeURIComponent(params.make), model: decodeURIComponent(params.model), part_code: decodeURIComponent(params.part_code),  part_name: decodeURIComponent(params.part_name) },{signal}).then( (response) => {
            if(response.status === 200){

                if(response.data.error_code == 404){
                    setPart({...part, error: true, isLoading: true});
                    return;
                }

                setPart({...part,
                    data: { ...part.data,
                        partImages: response.data.part_images || [],
                        adImages: response.data.ad_images || [],
                        part: response.data || [],
                        ad: response.data.ad,
                        schedule: response.data.schedule || [],
                        adParts: response.data.ad_parts,
                        no_image: response.data.no_image || "",
                        partNumbers: response.data.part_numbers || [],
                        criteria: response.data.criteria || [],
                        merchantLogo: response.data.merchant_logo || ""

                    },
                    isLoading: false
                })

                setPart(prevState => {
                    return{
                        ...prevState,
                        data: {
                            ...prevState.data,
                            ad: {
                                ...prevState.data.ad, part_title: response.data.part_title
                            }
                        }
                    }
                } );

                setHeaderData({
                    title : `${part.data.ad.make_title} ${part.data.ad.model_name} ${response.data.part_title}`,
                    subtitle : `${t('parts.Breakersforparts')} ${part.data.ad.make_title} ${part.data.ad.model_name} ${response.data.part_title}`
                });

                const partsImagesArr = [];
                for (let index = 0; index < response.data.part_images.length; ++index) {
                    partsImagesArr.push({ 'src': response.data.part_images[index].src}  );
                }
                setPartsImagesLightBox(partsImagesArr);

                const extraPartsImagesArr = [];
                for (let index = 0; index < response.data.extra_parts.parts.length; ++index) {
                    if(response.data.extra_parts.parts[index].images.length > 0){
                        for (let i = 0; i < response.data.extra_parts.parts[index].images.length; ++i){
                            extraPartsImagesArr.push({ 'src': response.data.extra_parts.parts[index].images[i].src}  );
                        }
                    }
                }
                setExtraPartsImagesLightBox(extraPartsImagesArr);

                const adImagesArr = [];
                for (let index = 0; index < response.data.ad_images.length; ++index) {
                    adImagesArr.push({ 'src': response.data.ad_images[index]}  );
                }
                setAdImagesLightBox(adImagesArr);

            }
        } ).catch((error) => {
            setPart({...part, error: true, isLoading: true});
        });

    }

    useEffect(() => {
        setPart({...part, isLoading: true});
        const controller = new AbortController();
        const signal = controller.signal;

        getPartPage(signal);

        return () => {controller.abort();}
    }, [params]);


    const jsonLdProduct = {
        sku: part.data.part.part_code,
        name: `${ t('parts.jsonLdName', { make: part.data.ad.make_title, model: part.data.ad.model_name, model_year: part.data.ad.model_year, partname: part.data.part.part_title } ) }`,
        image: part.data.partImages?.[0]?.src ?? part.data.adImages?.[0] ?? part.data.no_image,
        shortDescription: `${ t('meta_description.partPage', { make: part.data.ad.make_title, model: part.data.ad.model_name, model_year: part.data.ad.model_year, partname: part.data.part.part_title } ) }`,
        brand: part.data.ad.make_title,
        price: part?.data?.part?.price_with_vat,
        priceCurrency: 'EUR',
        inStock: Boolean(part.data.adParts && part.data.adParts.part_status_id !== 1),
        model: part.data.ad.model_name
    };

    return (

        <PageBox data={headerData} showAdds={false}>
            <SEO
                title={ t('parts.jsonLdName', { make: part.data.ad.make_title, model: part.data.ad.model_name, model_year: part.data.ad.model_year, partname: part.data.part.part_title } )}
                description={ t('meta_description.partPage', { make: part.data.ad.make_title, model: part.data.ad.model_name, model_year: part.data.ad.model_year, partname: part.data.part.part_title } )  }
                image={part.data.partImages?.[0]?.src ?? null}
                type="product"
            />
            <JsonLdPartsProduct
                product={jsonLdProduct}
            />
            {part.isLoading ? (
                <>
                    <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                    {part.error &&<div style={{ paddingTop: '30px', textAlign : 'center', color: 'red' }}>{t('parts.reqerror')}</div>}
                </>

            ) : (
                <>
                    <div className='page-header'>
                        {/*<PageHeader data={header}/>*/}  {/*  εχει το code αντι του search */}
                        <div className='page-header__row'>
                            <div className='page-header__content'>
                                <div className='page-header__content-row'>
                                    <div className='page-header__icon'><img src={part.data.part.logo} alt={part.data.ad.part_title} /> </div>
                                    <div className='page-header__title'>{part.data.ad.make_title} {part.data.ad.model_name} {part.data.ad.part_title}</div>
                                </div>
                            </div>
                            <div className='page-header__aside-part'>
                                <div className='system-code'>
                                    <div className='system-code__label'>{t('parts.itemcode')}</div>
                                    <div className='system-code__code mr-3'>{part.data.part.part_code}</div>
                                    <div className={`system-code__icon ${ part.data.adParts.part_status_id == 1 ? 'sold' : '' } ${ part.data.adParts.part_status_id == 2 ? 'storage' : '' } ${ part.data.adParts.part_status_id == 3 ? 'InVehicle' : '' } ${ part.data.adParts.part_status_id == 4 ? 'destroyed' : '' }  `}></div>
                                    <div className='system-code__label'>{part.data.adParts.part_status_title}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='page-body'>

                        <div className='UsedParts__row'>
                            <div className='UsedParts__img'>
                                { part.data.partImages.length > 0 ?  <>
                                    <Swiper
                                        thumbs={{ swiper: thumbsSwiper }}
                                        modules={[FreeMode, Navigation, Pagination, Thumbs]}
                                        spaceBetween={0}
                                        pagination={{ clickable: true }}
                                        navigation={true}
                                        slidesPerView={1}
                                        //onSwiper={(swiper) => console.log(swiper)}
                                        className='UsedPartsSlider'>
                                        {
                                            part.data.partImages.map((item, index) => {
                                                return(
                                                    <SwiperSlide key={index}>
                                                        <img src={item.src} alt='slide' />
                                                    </SwiperSlide>
                                                );
                                            })
                                        }
                                    </Swiper>

                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={4}
                                        freeMode={true}
                                        watchSlidesProgress={true}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper UsedPartsSliderThumbs"
                                        //onSwiper={setThumbsSwiper}
                                        onSwiper={(swiper) => setThumbsSwiper}
                                    >
                                        {
                                            part.data.partImages.map((item, index) => {
                                                return(
                                                    <SwiperSlide key={index}>
                                                        <img src={item.src} alt='slide' />
                                                    </SwiperSlide>
                                                );
                                            })
                                        }
                                    </Swiper>
                                </>
                                    : <img className="main_no_image" src={part.data.no_image} alt={part.data.ad.part_title}/>
                                }
                            </div>
                            <div className='UsedParts__details'>

                                <div className='UsedPartsTitle'>{ t('parts.details' ) }</div>

                                <div className='partNumbers UsedPartsDetails'>
                                    { part.data.partNumbers.length > 0 && <>
                                        <div className='partNumbers__label UsedPartsDetails__label'>{t('parts.reference')}</div>
                                        <div className='partNumbers__row UsedPartsDetails__content UsedPartsDetails__content--reference'>
                                            {
                                                part.data.partNumbers.map( (partNumber, index) => (
                                                    <div className='partNumbers__item' key={index}>{partNumber.part_number}</div>
                                                ) )
                                            }
                                        </div>
                                    </>}
                                </div>
                                {part.data.adParts.condition_title && <div className='UsedPartsDetails'>
                                    <div className='UsedPartsDetails__label'>Condition</div>
                                    <div className='UsedPartsDetails__content UsedPartsDetails__content--condition condition-used'>{part.data.adParts.condition_title}</div>
                                </div>}
                                {/*{ typeof part.data.adParts != 'undefined' && <>*/}
                                {/*    <div className='UsedPartsDetails UsedPartsDetails--comment  condition-used'>*/}
                                {/*        <div className='UsedPartsDetails__label'>Comment</div>*/}
                                {/*        <div className='UsedPartsDetails__content UsedPartsDetails__content--comment'>{part.data.adParts.comments}</div>*/}
                                {/*    </div>*/}
                                {/*</>}*/}
                                <div className='UsedPartsPrice'>
                                    <div className='UsedPartsPrice__label'>{t('parts.price' )}:</div>
                                    <div className='UsedPartsPrice__price'>{part.data.part.price_with_vat} €</div>
                                    <div className='UsedPartsPrice__vat'>{ t('parts.incVat' ) }</div>
                                </div>

                                <PartRequest parts={part.data.adParts.ads_parts_id} ads_id={part.data.ad.ads_id} merchant_email={part.data.ad.email} code={part.data.ad.code} />

                            </div>
                            <div className='UsedParts__description'>

                                <div className='UsedPartsTitle'>{ t('parts.carDescription' ) }</div>
                                <div className='UsedPartDescription'>
                                    <div className='UsedPartDescription__item'>
                                        <div className='UsedPartDescription__label'>{t('parts.Manufacturer')}</div>
                                        <div className='UsedPartDescription__value'>{part.data.ad.make_title}</div>
                                    </div>
                                    <div className='UsedPartDescription__item'>
                                        <div className='UsedPartDescription__label'>{t('parts.Model')}</div>
                                        <div className='UsedPartDescription__value'>{part.data.ad.model_name}</div>
                                    </div>
                                    <div className='UsedPartDescription__item'>
                                        <div className='UsedPartDescription__label'>{t('parts.ModelYear')}</div>
                                        <div className='UsedPartDescription__value'>{part.data.ad.model_year}</div>
                                    </div>
                                    { part.data.ad.klm_status && <div className='UsedPartDescription__item'>
                                        <div className='UsedPartDescription__label'>{t('parts.Kim')}</div>
                                        <div className='UsedPartDescription__value'>{part.data.ad.klm}</div>
                                    </div>}
                                    <div className='UsedPartDescription__item'>
                                        <div className='UsedPartDescription__label'>{t('parts.Bodytype')}</div>
                                        <div className='UsedPartDescription__value'>{part.data.ad.bodytype_title}</div>
                                    </div>
                                    {part.data.ad.ad_type_id  != 4 && <div className='UsedPartDescription__item'>
                                        <div className='UsedPartDescription__label'>{t('parts.Fueltype')}</div>
                                        <div className='UsedPartDescription__value'>{part.data.ad.fuel_title}</div>
                                    </div>}
                                    {part.data.ad.ad_type_id  != 4 && <div className='UsedPartDescription__item'>
                                        <div className='UsedPartDescription__label'>{t('parts.Enginepower')}</div>
                                        <div className='UsedPartDescription__value'>{part.data.ad.power}</div>
                                    </div>}
                                    {part.data.ad.ad_type_id  != 4 && <div className='UsedPartDescription__item'>
                                        <div className='UsedPartDescription__label'>{t('parts.Enginecapacity')}</div>
                                        <div className='UsedPartDescription__value'>{part.data.ad.cc_title}</div>
                                    </div>}

                                    {part.data.criteria.map((item, index) => {
                                        if (item.criteria.length > 0) {
                                            return (
                                                <div className='UsedPartDescription__item' key={index}>
                                                    <div className='UsedPartDescription__label'>{item.title}</div>
                                                    <div className='UsedPartDescription__value'>{item.criteria[0].title}</div>
                                                </div>
                                            );
                                        }

                                        return null;
                                    })}

                                </div>

                            </div>
                        </div>

                        <div className='UsedPartsAside__row'>
                            <div className='UsedPartsAside__col UsedPartsAside__col--left'>

                                { extraPartsImagesLightBox.length > 0 && <div className='UsedPartsGallery'>
                                    <div className='UsedPartsGallery__title'>{ t('parts.otherParts' ) }</div>
                                    <div className='UsedPartsGallery__row'>
                                        {/*{*/}
                                        {/*    extraPartsImagesLightBox.map((item, index) => {*/}
                                        {/*        return(*/}
                                        {/*            <div className='UsedPartsGallery__item' key={index} onClick={() => setOpenExtraPartsLightBox(true)}>*/}
                                        {/*                <img src={item.src} alt='parts'/>*/}
                                        {/*            </div>*/}
                                        {/*        );*/}
                                        {/*    })*/}
                                        {/*}*/}

                                        {
                                            extraPartsImagesLightBox.map((item, index) => {
                                                if (index < 7){
                                                    return(
                                                        <div className='UsedPartsGallery__item' key={index} onClick={() => setOpenExtraPartsLightBox(true)}>
                                                            <img src={item.src} alt='parts'/>
                                                        </div>
                                                    );
                                                }
                                                if (index === 7 && extraPartsImagesLightBox.length == 8){
                                                    return(
                                                        <div className='UsedPartsGallery__item' key={index} onClick={() => setOpenExtraPartsLightBox(true)}>
                                                            <img src={item.src} alt='parts'/>
                                                        </div>
                                                    );
                                                }
                                                if (index === 7 && extraPartsImagesLightBox.length > 8){
                                                    return(
                                                        <div className='UsedPartsGallery__item UsedPartsGallery__item--dark' key={index} onClick={() => setOpenExtraPartsLightBox(true)}>
                                                            <div className='position-relative'>
                                                                <img src={item.src} alt='parts'/>
                                                                <div className='UsedPartsGallery__text'>+{extraPartsImagesLightBox.length - index - 1} parts</div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                return(
                                                    <div className='UsedPartsGallery__item UsedPartsGallery__item--hide' key={index} onClick={() => setOpenExtraPartsLightBox(true)}>
                                                        <img src={item.src} alt='parts'/>
                                                    </div>
                                                );

                                            })
                                        }

                                    </div>
                                    <Lightbox
                                        open={openExtraPartsLightBox}
                                        close={() => setOpenExtraPartsLightBox(false)}
                                        slides={extraPartsImagesLightBox}
                                    />
                                </div>
                                }

                                { part.data.adImages.length > 0 && <div className='UsedPartsGallery'>
                                    <div className='UsedPartsGallery__title'>{ t('parts.carPhotos' ) }</div>
                                        <div className='UsedPartsGallery__row'>
                                        {
                                            part.data.adImages.map((item, index) => {
                                                if (index < 7){
                                                    return(
                                                        <div className='UsedPartsGallery__item' key={index} onClick={() => setOpenAdLightBox(true)}>
                                                            <img src={item} alt='ads'/>
                                                        </div>
                                                    );
                                                }
                                                if (index === 7 && extraPartsImagesLightBox.length == 8){
                                                    return(
                                                        <div className='UsedPartsGallery__item' key={index} onClick={() => setOpenAdLightBox(true)}>
                                                            <img src={item} alt='ads'/>
                                                        </div>
                                                    );
                                                }
                                                if (index === 7 && extraPartsImagesLightBox.length > 8){
                                                    return(
                                                        <div className='UsedPartsGallery__item UsedPartsGallery__item--dark' key={index} onClick={() => setOpenAdLightBox(true)}>
                                                            <div className='position-relative'>
                                                                <img src={item} alt='ads'/>
                                                                <div className='UsedPartsGallery__text'>+{extraPartsImagesLightBox.length - index - 1} parts</div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                return(
                                                    <div className='UsedPartsGallery__item UsedPartsGallery__item--hide' key={index} onClick={() => setOpenAdLightBox(true)}>
                                                        <img src={item} alt='ads'/>
                                                    </div>
                                                );
                                            })
                                        }
                                        </div>
                                        <Lightbox
                                            open={openAdLightBox}
                                            close={() => setOpenAdLightBox(false)}
                                            slides={adImagesLightBox}
                                            // slides={[
                                            //     { src: "https://d29w09sw5h2242.cloudfront.net/84/merchants/1/images/ads/1/1679488104.jpg" },
                                            //     { src: "https://d29w09sw5h2242.cloudfront.net/84/merchants/1/images/ads/1/1679488106.jpg" },
                                            //     { src: "https://d29w09sw5h2242.cloudfront.net/84/merchants/1/images/ads/1/1679488104.jpg" },
                                            //     { src: "https://d29w09sw5h2242.cloudfront.net/84/merchants/1/images/ads/1/1679664721.jpg" },
                                            // ]}
                                        />
                                    </div>

                                }

                            </div>
                            <div className='UsedPartsAside__col UsedPartsAside__col--right'>

                                <div className='UsedPartsAside__title'>{ t('parts.contactDetails' ) }</div>

                                <div className='UsedPartsContact'>
                                    <div className='UsedPartsContact__row'>
                                        <div className='UsedPartsContact__img'>
                                            { part.data.merchantLogo && <div className='UsedPartsContact__img-wrap'>
                                                <img src={part.data.merchantLogo} alt={part.data.ad.company} />
                                            </div>}
                                        </div>
                                        <div className='UsedPartsContact__content'>
                                            <Link to={`/${i18n.language}/mini-site/cars/${part.data.ad.merchant_id}/${part.data.ad.merchant_slug}`} className='UsedPartsContact__title'>{part.data.ad.company}</Link>
                                            <Link to={`/${i18n.language}/mini-site/cars/${part.data.ad.merchant_id}/${part.data.ad.merchant_slug}`} className='UsedPartsContact__view-all'>{t('parts.Viewallcars')}</Link>
                                        </div>
                                        <div className='UsedPartsContact__info'>

                                            <div className='icon-link'>
                                                <div className='icon-link__icon'><MapGreen/></div>
                                                <div className='icon-link__label small-text'>{part.data.ad.city}, &nbsp;{part.data.ad.address}</div>
                                            </div>

                                            { part.data.ad.contact_choice == 1 && part.data.ad.phone && <a href={`tel:+${part.data.ad.phone_code}${part.data.ad.phone}`} className='btn btn-secondary btn-icon btn-icon-left btn--phone'>
                                                <ShowPhone/>
                                                {part.data.ad.phone}
                                            </a>}
                                            { part.data.ad.contact_choice == 2 && part.data.ad.email && <a href={`mailto${part.data.ad.email}`} target='_blank' rel='noopener' className='btn btn-secondary btn--phone'>
                                                {part.data.ad.email}
                                            </a>}

                                            {/*<button className='btn btn-primary btn-icon btn-icon-left btn--whatsup'>*/}
                                            {/*    <Whatup/>*/}
                                            {/*    whatsapp*/}
                                            {/*</button>*/}

                                        </div>



                                        <div className='UsedPartsContact__time'>

                                            <div className='row extra-small-gutters'>
                                                <div className='col-auto' style={{paddingTop: '40px'}}>
                                                    <TimeGreen/>
                                                </div>
                                                <div className='col'>
                                                    <div className='row extra-small-gutters py-2'>
                                                        <div className='col-4'></div>
                                                        <div className='col-4'><span className='time-table-box__header'>{t('parts.MorningHours')} </span></div>
                                                        <div className='col-4'><span className='time-table-box__header'>{t('parts.EveningHours')} </span></div>
                                                    </div>
                                                    {
                                                        part.data.schedule.map( (item, index) => (
                                                            <div className='row extra-small-gutters py-1' key={index}>
                                                                <div className='col-4'><span className='time-table-box__label'>{item.description}:</span></div>
                                                                <div className='col-4'><span className='time-table-box__label'>
                                                                {item.time_morning_from == '-1' ? (
                                                                    <>{t('parts.closed')}</>
                                                                ) : (
                                                                    <>{item.time_morning_from} - {item.time_morning_to}</>
                                                                )}

                                                            </span></div>
                                                                <div className='col-4'><span className='time-table-box__label'>
                                                                {item.time_evening_from == '-1' ? (
                                                                    <>{t('parts.closed')}</>
                                                                ) : (
                                                                    <>{item.time_evening_from} - {item.time_evening_to}</>
                                                                )}

                                                            </span></div>
                                                            </div>
                                                        ) )
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                { part.data.part.seller_information &&
                                    <>
                                        <div className='UsedPartsAside__title'>{ t('parts.sellerInfo' ) }</div>
                                        <div className='UsedPartsAside__text' dangerouslySetInnerHTML={{__html: `${part.data.part.seller_information}`}} />
                                    </>
                                }
                                {/*{ part.data.part.more_information &&*/}
                                {/*    <>*/}
                                {/*        <div className='UsedPartsAside__title'>{ t('parts.moreInfo' ) }</div>*/}
                                {/*        <div className='UsedPartsAside__text' dangerouslySetInnerHTML={{__html: `${part.data.part.more_information}`}} />*/}
                                {/*    </>*/}
                                {/*}*/}
                                { part.data.part.warranty &&
                                    <>
                                        <div className='UsedPartsAside__title'>{ t('parts.productWarranty' ) }</div>
                                        <div className='UsedPartsAside__text' dangerouslySetInnerHTML={{__html: `${part.data.part.warranty}`}} />
                                    </>
                                }
                                { part.data.part.shipment &&
                                    <>
                                        <div className='UsedPartsAside__title'>{ t('parts.productShippment' ) }</div>
                                        <div className='UsedPartsAside__text' dangerouslySetInnerHTML={{__html: `${part.data.part.shipment}`}} />
                                    </>
                                }
                            </div>
                        </div>

                    </div>
                </>
            )}


        </PageBox>
    );
};

export default PartPage;
